import React from "react";

const BlogsArea = () => {
  return (
    <>
      <section className="latest-blog-area">
        <div className="container">
          {/* <div className="row">
      <div className="col-md-12">
        <div className="sec-title pull-left">
          <h2>Latest <span>News</span></h2>
          <span className="decor" />
        </div>
        <div className="more-blog-button pull-right">
          <a className="thm-btn bg-cl-1" >More News</a> 
        </div>
      </div>
    </div>    */}
          <div className="row">
            <div className="col-md-4">
              <div className="single-blog-item">
                <div className="img-holder">
                <iframe
                  style={{ height: 250, width: "100%" }}
                  src="https://www.youtube.com/embed/JwXcucumip0"
                  frameBorder={0}
                  allowFullScreen
                />
                  <div className="overlay">
                    <div className="box">
                      <div className="content">
                        <a
                          href="https://www.youtube.com/embed/JwXcucumip0"
                          title="Service Title"
                          className="link"
                          target="_blank"
                        >
                          <i className="fa fa-link" aria-hidden="true" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="single-blog-item">
                <div className="img-holder">
                <iframe
                  style={{ height: 250, width: "100%" }}
                  src="https://www.youtube.com/embed/Ai7nc6xT1zw"
                  frameBorder={0}
                  allowFullScreen
                />
                  <div className="overlay">
                    <div className="box">
                      <div className="content">
                        <a
                         href="https://www.youtube.com/embed/Ai7nc6xT1zw"
                         title="Service Title"
                         className="link"
                          target="_blank"
                        >
                          <i className="fa fa-link" aria-hidden="true" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="single-blog-item">
                <div className="img-holder">
                <iframe
                  style={{ height: 250, width: "100%" }}
                  src="https://www.youtube.com/embed/bAuxeF8QUn8"
                  frameBorder={0}
                  allowFullScreen
                />
                  <div className="overlay">
                    <div className="box">
                      <div className="content">
                        <a
                          href="https://www.youtube.com/embed/bAuxeF8QUn8"
                          title="Service Title"
                          className="link"
                          target="_blank"
                        >
                          <i className="fa fa-link" aria-hidden="true" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogsArea;
